"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Upload_exports = {};
__export(Upload_exports, {
  default: () => Upload_default
});
module.exports = __toCommonJS(Upload_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M3.41016 12.6914C3.55339 12.6914 3.67057 12.7435 3.76172 12.8477C3.86589 12.9388 3.91797 13.056 3.91797 13.1992V15.6992C3.91797 16.0247 4.02865 16.3047 4.25 16.5391C4.48438 16.7604 4.76432 16.8711 5.08984 16.8711H15.9102C16.2357 16.8711 16.5091 16.7604 16.7305 16.5391C16.9648 16.3047 17.082 16.0247 17.082 15.6992V13.1992C17.082 13.056 17.1276 12.9388 17.2188 12.8477C17.3229 12.7435 17.4466 12.6914 17.5898 12.6914C17.7201 12.6914 17.8307 12.7435 17.9219 12.8477C18.026 12.9388 18.0781 13.056 18.0781 13.1992V15.6992C18.0781 16.2982 17.8633 16.8125 17.4336 17.2422C17.0169 17.6589 16.5091 17.8672 15.9102 17.8672H5.08984C4.49089 17.8672 3.97656 17.6589 3.54688 17.2422C3.13021 16.8125 2.92188 16.2982 2.92188 15.6992V13.1992C2.92188 13.056 2.96745 12.9388 3.05859 12.8477C3.16276 12.7435 3.27995 12.6914 3.41016 12.6914ZM10.5 14.4883C10.3568 14.4883 10.2331 14.4427 10.1289 14.3516C10.0378 14.2474 9.99219 14.1237 9.99219 13.9805V3.98047C9.99219 3.85026 10.0378 3.73958 10.1289 3.64844C10.2331 3.54427 10.3568 3.49219 10.5 3.49219C10.6432 3.49219 10.7604 3.54427 10.8516 3.64844C10.9557 3.73958 11.0078 3.85026 11.0078 3.98047V13.9805C11.0078 14.1237 10.9557 14.2474 10.8516 14.3516C10.7604 14.4427 10.6432 14.4883 10.5 14.4883ZM7.23828 6.63672C7.13411 6.53255 7.08203 6.41536 7.08203 6.28516C7.08203 6.14193 7.1276 6.02474 7.21875 5.93359L10.1094 3.04297C10.2266 2.92578 10.3633 2.86719 10.5195 2.86719C10.6888 2.86719 10.832 2.92578 10.9492 3.04297L13.8398 5.91406C13.944 6.00521 13.9961 6.1224 13.9961 6.26562C13.9961 6.39583 13.9505 6.51302 13.8594 6.61719C13.7552 6.70833 13.6315 6.75391 13.4883 6.75391C13.3581 6.75391 13.2409 6.70833 13.1367 6.61719L10.5391 4.03906L7.94141 6.63672C7.83724 6.72786 7.71354 6.77344 7.57031 6.77344C7.4401 6.77344 7.32943 6.72786 7.23828 6.63672Z",
      fill: "currentColor"
    }
  )
);
const SvgUpload = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var Upload_default = SvgUpload;
